import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import * as moment from 'moment';
import { MessageService } from 'primeng/api';
import readXlsxFile, { readSheetNames } from 'read-excel-file';
import { Subject, take } from 'rxjs';
import { AirportGateway } from 'src/app/application/gateway/AirportGateway';
import { AuthGateway } from 'src/app/application/gateway/AuthGateway';
import { CompanyGateway } from 'src/app/application/gateway/CompanyGateway';
import { ConsigneeGateway } from 'src/app/application/gateway/ConsigneeGateway';
import { CountryGateway } from 'src/app/application/gateway/CountryGateway';
import { DirectSaleProgramGateway } from 'src/app/application/gateway/DirectSaleProgramGateway';
import { DocumentServiceGateway } from 'src/app/application/gateway/DocumentServiceGateway';
import { FridgeStorageGateway } from 'src/app/application/gateway/FridgeStorageGateway';
import { ImportOrderDetailGateway } from 'src/app/application/gateway/ImportOrderDetailGateway';
import { ImportOrderGateway } from 'src/app/application/gateway/ImportOrderGateway';
import { NotifierGateway } from 'src/app/application/gateway/NotifierGateway';
import { OperationDocumentTypeGateway } from 'src/app/application/gateway/OperationDocumentTypeGateway';
import { OperationGateway } from 'src/app/application/gateway/OperationGateWay';
import { PalletGateway } from 'src/app/application/gateway/PalletGateway';
import { PortGateway } from 'src/app/application/gateway/PortGateway';
import { QualityControlCompanyGateway } from 'src/app/application/gateway/QualityControlCompanyGateway';
import { CopyPasteExcelService } from 'src/app/application/service/CopyPasteExcelService';
import { OperationService } from 'src/app/application/service/OperationService';
import { Airport } from 'src/app/domain/models/Airport';
import { Company } from 'src/app/domain/models/Company';
import { Consignee } from 'src/app/domain/models/Consignee';
import { Country } from 'src/app/domain/models/Country';
import { DirectSaleProgram } from 'src/app/domain/models/DirectSaleProgram';
import { NewFridgeStorage } from 'src/app/domain/models/FridgeStorage';
import { GenericOrderDetail, ImportOrderDetailInformation, ImportOrderInformation } from 'src/app/domain/models/ImportOrder';
import { Notifier } from 'src/app/domain/models/Notifier';
import { OperationDocumentType, UploadOperationFileRequest } from 'src/app/domain/models/Operation';
import { CreatePalletDataRequest, CreatePalletPriceRequest, CreatePalletsRequest, LatamPalletDto, NewPallet, PalletPrice } from 'src/app/domain/models/Pallet';
import { Port } from 'src/app/domain/models/Port';
import { QualityControlCompany, QualityControlCompanySpecies, UpdateControlCompanyRequest } from 'src/app/domain/models/QCCompany';
import { QualityControlReview } from 'src/app/domain/models/QualityControlReview';
import { Species } from 'src/app/domain/models/Species';
import { BasicUser } from 'src/app/domain/models/User';
import { Routes } from 'src/app/infrastructure/routes';
import { AssignStockComponent } from 'src/app/ui/components/assign-stock/assign-stock.component';
import { ErrorMessageUtil } from 'src/app/ui/util/error-message-util';
import { excelUtils } from 'src/app/ui/util/excel-utils';
import { OrderUtils } from 'src/app/ui/util/order-utils';
import { SessionVarUtils } from 'src/app/ui/util/session-var-util';
import { SpeciesUtils } from 'src/app/ui/util/species-utils';

interface AdditionalInfoSection {
  key: string,
  label: string,
  icon: any,
  isSelected: boolean,
  isValid?: null | boolean,
  isAvailable?: null | boolean
}
@Component({
  selector: 'app-verify-pallets-component',
  templateUrl: './verify-pallets-component.component.html',
  styleUrls: ['./verify-pallets-component.component.css']
})
export class VerifyPalletsComponentComponent implements OnInit, OnDestroy {

  visibleQCCompany: boolean = false
  visibleDisclaimerQCDialog: boolean = false
  visibleStockDialog: boolean = false

  qcCompanies: QualityControlCompany[] = []

  latamPallet: LatamPalletDto[] = []

  visibleLatamLoad: boolean = false
  visibleMoreInfo: boolean = false

  defaultLoadPallet: LatamPalletDto = {
    specieName: '',
    varietyName: '',
    producer: '',
    speciesSize: '',
    category: '',
    netWeight: 0,
    boxes: 0,
    pallets:0
  };

  selectedDefaultPallet: LatamPalletDto | undefined
  selectedPalletIndex: number = 0;

  itemBeforeSelect: any;
  companySpeciesSelected: QualityControlCompanySpecies[] = []

  verifyDeleteConfig: boolean = false

  noQCCompany: QualityControlCompany = {
    id: 0,
    profileId: 0,
    isConsolidateContainer: false,
    basePricePerContainer: 0,
    hasQCSystem: false,
    pricePerPallet: 0,
    pricePerContainer: 0,
    basePricePerPallet: 0,
    profile: {
      id: 0,
      companyName: 'NO QC',
      vat: 0,
      type: 0,
      contactName: '',
      contactEmail: '',
      contactPhone: '',
      contactAddress: '',
      contactCity: '',
      contactCountryId: 0,
      lang:'',
      hasTwoAuthetication: false,
      updaterUsername: ''

    }
  }

  maxFileSize: number = 20000000

  itemQCSelected: any = this.noQCCompany;

  @Input()
  isClosedSale: boolean = false

  @Input()
  exportOfferId: number | undefined

  @Input()
  directSaleProgramId: any

  @Input()
  dto: ImportOrderDetailInformation | undefined

  @Output()
  updatePalletEvent: EventEmitter<any> = new EventEmitter()

  detail: GenericOrderDetail | undefined

  programId: number | undefined

  activeIndex: number = 0;
  documentTypeViewId: number | undefined

  destinationQCCompanies: QualityControlCompany[] = []
  selectedDestinationQCCompany: QualityControlCompany | undefined
  originQCCompanies: QualityControlCompany[] = []
  selectedOriginQCCompany: QualityControlCompany | undefined
  originQCReviews: QualityControlReview[] = []
  destinationQCReviews: QualityControlReview[] = []
  fridgeStorages: any[] = []

  containerCbm: number | undefined
  containerTemperature: number | undefined

  existCurrentPrices: boolean = false;
  hideBlur: boolean = false;

  programType: number = 0

  visibleLoadInformation: boolean = false
  tabActiveIndex: number = 0;
  excelFile: any
  excelSheets: any
  selectedSheet: string = ''
  startRow: number = 1
  folioColumn: string = ''
  caliberColumn: string = ''
  producerColumn: string = ''
  showDiv: string = 'certificates';
  folios: any[] = []
  readedFolios: any[] = []
  readedCalibers: any[] = []
  readedCaliberMillimeters: any[] = []
  columns: string[] = [
    'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z',
    'AA', 'AB', 'AC', 'AD', 'AE', 'AF', 'AG', 'AH', 'AI', 'AJ', 'AK', 'AL', 'AM', 'AN', 'AO', 'AP', 'AQ', 'AR', 'AS', 'AT', 'AU', 'AV', 'AW', 'AX', 'AY', 'AZ',
    'BA', 'BB', 'BC', 'BD', 'BE', 'BF', 'BG', 'BH', 'BI', 'BJ', 'BK', 'BL', 'BM', 'BN', 'BO', 'BP', 'BQ', 'BR', 'BS', 'BT', 'BU', 'BV', 'BW', 'BX', 'BY', 'BZ',
    'CA', 'CB', 'CC', 'CD', 'CE', 'CF', 'CG', 'CH', 'CI', 'CJ', 'CK', 'CL', 'CM', 'CN', 'CO', 'CP', 'CQ', 'CR', 'CS', 'CT', 'CU', 'CV', 'CW', 'CX', 'CY', 'CZ',
    'DA', 'DB', 'DC', 'DD', 'DE', 'DF', 'DG', 'DH', 'DI', 'DJ', 'DK', 'DL', 'DM', 'DN', 'DO', 'DP', 'DQ', 'DR', 'DS', 'DT', 'DU', 'DV', 'DW', 'DX', 'DY', 'DZ',
    'EA', 'EB', 'EC', 'ED', 'EE', 'EF', 'EG', 'EH', 'EI', 'EJ', 'EK', 'EL', 'EM', 'EN', 'EO', 'EP', 'EQ', 'ER', 'ES', 'ET', 'EU', 'EV', 'EW', 'EX', 'EY', 'EZ',
    'FA', 'FB', 'FC', 'FD', 'FE', 'FF', 'FG', 'FH', 'FI', 'FJ', 'FK', 'FL', 'FM', 'FN', 'FO', 'FP', 'FQ', 'FR', 'FS', 'FT', 'FU', 'FV', 'FW', 'FX', 'FY', 'FZ',
    'GA', 'GB', 'GC', 'GD', 'GE', 'GF', 'GG', 'GH', 'GI', 'GJ', 'GK', 'GL', 'GM', 'GN', 'GO', 'GP', 'GQ', 'GR', 'GS', 'GT', 'GU', 'GV', 'GW', 'GX', 'GY', 'GZ',
    'HA', 'HB', 'HC', 'HD', 'HE', 'HF', 'HG', 'HH', 'HI', 'HJ', 'HK', 'HL', 'HM', 'HN', 'HO', 'HP', 'HQ', 'HR', 'HS', 'HT', 'HU', 'HV', 'HW', 'HX', 'HY', 'HZ',
    'IA', 'IB', 'IC', 'ID', 'IE', 'IF', 'IG', 'IH', 'II', 'IJ', 'IK', 'IL', 'IM', 'IN', 'IO', 'IP', 'IQ', 'IR', 'IS', 'IT', 'IU', 'IV', 'IW', 'IX', 'IY', 'IZ',
    'JA', 'JB', 'JC', 'JD', 'JE', 'JF', 'JG', 'JH', 'JI', 'JJ', 'JK', 'JL', 'JM', 'JN', 'JO', 'JP', 'JQ', 'JR', 'JS', 'JT', 'JU', 'JV', 'JW', 'JX', 'JY', 'JZ',
    'KA', 'KB', 'KC', 'KD', 'KE', 'KF', 'KG', 'KH', 'KI', 'KJ', 'KK', 'KL', 'KM', 'KN', 'KO', 'KP', 'KQ', 'KR', 'KS', 'KT', 'KU', 'KV', 'KW', 'KX', 'KY', 'KZ',
    'LA', 'LB', 'LC', 'LD', 'LE', 'LF', 'LG', 'LH', 'LI', 'LJ', 'LK', 'LL', 'LM', 'LN', 'LO', 'LP', 'LQ', 'LR', 'LS', 'LT', 'LU', 'LV', 'LW', 'LX', 'LY', 'LZ',
    'MA', 'MB', 'MC', 'MD', 'ME', 'MF', 'MG', 'MH', 'MI', 'MJ', 'MK', 'ML', 'MM', 'MN', 'MO', 'MP', 'MQ', 'MR', 'MS', 'MT', 'MU', 'MV', 'MW', 'MX', 'MY', 'MZ',
    'NA', 'NB', 'NC', 'ND', 'NE', 'NF', 'NG', 'NH', 'NI', 'NJ', 'NK', 'NL', 'NM', 'NN', 'NO', 'NP', 'NQ', 'NR', 'NS', 'NT', 'NU', 'NV', 'NW', 'NX', 'NY', 'NZ',
    'OA', 'OB', 'OC', 'OD', 'OE', 'OF', 'OG', 'OH', 'OI', 'OJ', 'OK', 'OL', 'OM', 'ON', 'OO', 'OP', 'OQ', 'OR', 'OS', 'OT', 'OU', 'OV', 'OW', 'OX', 'OY', 'OZ',
    'PA', 'PB', 'PC', 'PD', 'PE', 'PF', 'PG', 'PH', 'PI', 'PJ', 'PK', 'PL', 'PM', 'PN', 'PO', 'PP', 'PQ', 'PR', 'PS', 'PT', 'PU', 'PV', 'PW', 'PX', 'PY', 'PZ',
    'QA', 'QB', 'QC', 'QD', 'QE', 'QF', 'QG', 'QH', 'QI', 'QJ', 'QK', 'QL', 'QM', 'QN', 'QO', 'QP', 'QQ', 'QR', 'QS', 'QT', 'QU', 'QV', 'QW', 'QX', 'QY', 'QZ',
    'RA', 'RB', 'RC', 'RD', 'RE', 'RF', 'RG', 'RH', 'RI', 'RJ', 'RK', 'RL', 'RM', 'RN', 'RO', 'RP', 'RQ', 'RR', 'RS', 'RT', 'RU', 'RV', 'RW', 'RX', 'RY', 'RZ',
    'SA', 'SB', 'SC', 'SD', 'SE', 'SF', 'SG', 'SH', 'SI', 'SJ', 'SK', 'SL', 'SM', 'SN', 'SO', 'SP', 'SQ', 'SR', 'SS', 'ST', 'SU', 'SV', 'SW', 'SX', 'SY', 'SZ',
    'TA', 'TB', 'TC', 'TD', 'TE', 'TF', 'TG', 'TH', 'TI', 'TJ', 'TK', 'TL', 'TM', 'TN', 'TO', 'TP', 'TQ', 'TR', 'TS', 'TT', 'TU', 'TV', 'TW', 'TX', 'TY', 'TZ',
    'UA', 'UB', 'UC', 'UD', 'UE', 'UF', 'UG', 'UH', 'UI', 'UJ', 'UK', 'UL', 'UM', 'UN', 'UO', 'UP', 'UQ', 'UR', 'US', 'UT', 'UU', 'UV', 'UW', 'UX', 'UY', 'UZ',
    'VA', 'VB', 'VC', 'VD', 'VE', 'VF', 'VG', 'VH', 'VI', 'VJ', 'VK', 'VL', 'VM', 'VN', 'VO', 'VP', 'VQ', 'VR', 'VS', 'VT', 'VU', 'VV', 'VW', 'VX', 'VY', 'VZ',
    'WA', 'WB', 'WC', 'WD', 'WE', 'WF', 'WG', 'WH', 'WI', 'WJ', 'WK', 'WL', 'WM', 'WN', 'WO', 'WP', 'WQ', 'WR', 'WS', 'WT', 'WU', 'WV', 'WW', 'WX', 'WY', 'WZ',
    'XA', 'XB', 'XC', 'XD', 'XE', 'XF', 'XG', 'XH', 'XI', 'XJ', 'XK', 'XL', 'XM', 'XN', 'XO', 'XP', 'XQ', 'XR', 'XS', 'XT', 'XU', 'XV', 'XW', 'XX', 'XY', 'XZ',
    'YA', 'YB', 'YC', 'YD', 'YE', 'YF', 'YG', 'YH', 'YI', 'YJ', 'YK', 'YL', 'YM', 'YN', 'YO', 'YP', 'YQ', 'YR', 'YS', 'YT', 'YU', 'YV', 'YW', 'YX', 'YY', 'YZ',
    'ZA', 'ZB', 'ZC', 'ZD', 'ZE', 'ZF', 'ZG', 'ZH', 'ZI', 'ZJ', 'ZK', 'ZL', 'ZM', 'ZN', 'ZO', 'ZP', 'ZQ', 'ZR', 'ZS', 'ZT', 'ZU', 'ZV', 'ZW', 'ZX', 'ZY', 'ZZ'
  ]


  profile: BasicUser | undefined

  pallets: NewPallet  [] = []

  palletsPrice: PalletPrice[] = []

  currentPrices: PalletPrice[] = []

  visiblePalletsPrice: boolean = false
  visibleCurrentPalletsPrice: boolean = false
  withProducer: boolean = false

  fridgeStorageOptions: any[] = []
  loadFridgestorageDialogVisible: boolean = false
  countries: Country[] = []

  readFile: boolean = false
  importOrderInfo: ImportOrderInformation | undefined
  directSaleProgram: DirectSaleProgram | undefined

  fridgestorageFormGroup: FormGroup = this._formBuilder.group({
    fridgestorageName: [null, Validators.required],
    fridgestorageVat: [null],
    fridgestorageContactName: [null, Validators.required],
    fridgestorageContactAddress: [null, Validators.required],
    fridgestorageContactCity: [null, Validators.required],
    fridgestorageContactEmail: [null, [Validators.required, Validators.email]],
    fridgestorageContactPhone: [null, Validators.required],
    fridgestorageContactCountryId: [null, Validators.required],
    fridgestorageFDA: [null],
  })

  isEdit: boolean = false

  orderType: string = 'Import'

  palletFormGroup: FormGroup = this._formBuilder.group({
    startRow: [2, Validators.required],
    endRow:[],
    folioColumn: ['A', Validators.required],
    speciesColumn: ['B', Validators.required],
    varietyColumn: ['C', Validators.required],
    producerColumn: ['D', Validators.required],
    cspColumn: ['E'],
    csgColumn: ['F'],
    speciesSizeColumn: ['G'],
    categoryColumn: ['H'],
    harvestDateColumn: ['I'],
    qualityControlDateColumn: ['J'],
    packagingColumn: ['K'],
    palletTypeColumn: ['L'],
    tagColumn: ['M'],
    bagTypeColumn: ['N'],
    boxSizeColumn: ['O'],
    netWeightColumn: ['P'],
    fridgeStorageColumn: ['Q'],
    boxesPerPalletColumn: ['Q'],
    markColumn: ['R'],
    temptaleColumn: ['S'],
    originCountryColumn: ['T'],
    gradeColumn: ['U'],

  })

  latamPalletForm: FormGroup = this._formBuilder.group({
    csp: [null],
    csg: [null],
    harvestDate: [null],
    qualityControlDate: [null],
    packaging: [null],
    palletType: [null],
    tag: [null],
    bagType: [null],
    boxSize: [null],
    mark: [null],
  })

  directSaleFormGroup: FormGroup = this._formBuilder.group({
    fridgeStorageId: [null, Validators.required],
    harvestDate: [null, Validators.required],
    shelfLife: [null],
    readyToLoadDate: [null],
    containerCbm: [null, Validators.required],
    containerTemperature: [null, Validators.required],
    forwarder: [null, Validators.required],
    customAgent: [null, Validators.required],
    observations: [null],
    consigneeId: [null, Validators.required],
    notifyId: [null, Validators.required],
    destinationPortId: [null],
    destinationCountryId: [null, Validators.required],
    destinationAirportId: [null]
  })

  submit: boolean = false
  success: boolean = false
  loading: boolean = false
  isCreate: boolean = false

  companyForwarders: Company[] = []
  companyCustomAgents: Company[] = []
  selectedCompanyForwarder: number | undefined
  selectedCompanyCustomAgent: number | undefined

  consignees: Consignee[] = []
  notifies: Notifier[] = []
  selectedCountryTo: Country | undefined
  ports: Port[] = []
  airports: Airport[] = []

  operationDocumentTypes: OperationDocumentType[] = []

  orderDetailInformation: ImportOrderDetailInformation | undefined;

  additionalInfoSections: AdditionalInfoSection[] = []
  selectedInfoSection: string = ''
  visibleOperationUploadDialog: boolean = false
  uploadedFiles: any[] = []
  name: string = ""

  loadPalletsStep: number = 1
  private readonly destroy = new Subject<void>();

  constructor(private _router: Router,
    private _messageService: MessageService,
    private _formBuilder: FormBuilder,
    private _palletService: PalletGateway,
    private _authService: AuthGateway,
    public translate: TranslateService,
    private _documentService: DocumentServiceGateway,
    private _fridgeStorageService: FridgeStorageGateway,
    private _qualityControlService: QualityControlCompanyGateway,
    private _countryService: CountryGateway,
    private _importDetailService: ImportOrderDetailGateway,
    private _companyService: CompanyGateway,
    private _consigneeService: ConsigneeGateway,
    private _notifyService: NotifierGateway,
    private _importOrderService: ImportOrderGateway,
    private _airportService: AirportGateway,
    private _portService: PortGateway,
    private _directaSaleProgramService: DirectSaleProgramGateway,
    private _operationDocumentTypeService: OperationDocumentTypeGateway,
    private _operationService: OperationGateway,
    private readonly copyPasteExcelService: CopyPasteExcelService

  ) {
  }

  ngOnInit(): void {
    this.profile = this._authService.getUser()
    this.getLabelsOrder()
    this.getAllQcType()

    if(this.dto) {
      this.detail = this.dto.importOrderDetail
      if(this.dto.importOrderDetail.orderStatus === 4)
      {
        this.hideBlur = true
      }else{
        this.hideBlur = false;
      }
      this.pallets = this.dto.pallets
      this.withProducer = this.detail.palletConfigurationProducer ?? false
      this.destinationQCCompanies = this.dto.destinationQCCompanies
      this.selectedDestinationQCCompany = this.dto.destinationQCCompany
      this.originQCCompanies = this.dto.originQCCompanies
      this.selectedOriginQCCompany = this.dto.originQCCompany
      this.originQCReviews = this.dto.originQCReviews
      this.destinationQCReviews = this.dto.destinationQCReviews
      this.containerCbm = this.dto.containerCbm
      this.containerTemperature = this.dto.containerTemperature
      if(this.pallets && this.pallets.length > 0 && this.profile?.profileType == 'Exporter') {

        let i = 0
        this.pallets.forEach(x => {
          x.dataKey = i
          i++
        })

        this.isEdit = true
      }
      else {
        if(this.profile?.profileType == 'Exporter') {
          this.isCreate = true
          this.generatePallets()
        }
      }

      if(this.detail) {
        this.exportOfferId = this.detail.exportOfferId
      }
    }
    this.getFridgeStorages()
    this.getPriceConfiguration()
    this.loadCountries()
    this.loadQualityControlCompany();
    this.loadDirectSaleForm()
    this.loadCompanies(0) // Forwarders
    this.loadCompanies(1) // Custom Agents
    if(this.isClosedSale){
      this.getImportOrder()
      this.getDirectSaleProgram()
    }

    var sessionActiveIndex = sessionStorage.getItem('_verify_pallets_active_index');
    if(sessionActiveIndex){
      this.activeIndex = parseInt(sessionActiveIndex)
    }
    this.getAdditionalInfoSections()
  }

  getAdditionalInfoSections() {
    this.additionalInfoSections = [
      { key: 'cold-storage', label: this.translateInfo('FridstorageSetupTitle'), icon: 'mode_cool', isSelected: true, isAvailable: true },
      { key: 'instructive', label: this.translateInfo('InstructiveInformationTitle'), icon: 'description', isSelected: false, isAvailable: true },
      { key: 'container', label: this.translateInfo('ContainerSetupTitle'), icon: 'package_2', isSelected: false },
      { key: 'assignment', label: this.translateInfo('AssignmentTitle'), icon: 'group', isSelected: false },
      { key: 'observations', label: this.translateInfo('ObservationsTitle'), icon: 'article', isSelected: false },
    ]
    if (!this.detail?.isSelectOriginQCCompany) {
      this.additionalInfoSections.push({ key: 'qc-review', label: this.translateInfo('OriginQCReviewTitle'), icon: 'search', isSelected: false })
    }
    if (this.detail !== undefined) {
      this.additionalInfoSections.forEach((el) => {
        el.isAvailable = true
      })
    }
    this.selectedInfoSection = this.additionalInfoSections[0].key
  }

  translateInfo(key: string) {
    return this.translate.instant(`UserPages.UserPurchaseOrders.VerifyPalletsPage.${key}`)
  }

  onSelectInfoSection(targetSection: AdditionalInfoSection) {
    if (targetSection.key === this.selectedInfoSection) return

    const currentIndex = this.additionalInfoSections.findIndex(el => el.key === this.selectedInfoSection);
    const targetIndex = this.additionalInfoSections.findIndex(el => el.key === targetSection.key);
    if ((currentIndex - targetIndex) === 1) { // Si navegamos a la sección previa
      this.goToPreviousSection();
      return
    }
    else if ((currentIndex - targetIndex) === -1) { // Si navegamos a la sección siguiente
      this.goToNextSection();
      return
    }

     // Si navegamos a cualquier otra sección
    const validSection = this.validateCurrentSection(this.selectedInfoSection) || this.validateCurrentSection(this.selectedInfoSection) === null
    if (targetSection.isAvailable) {
      this.additionalInfoSections[currentIndex].isValid = this.validateCurrentSection(this.selectedInfoSection);
      if (validSection) {
        this.selectedInfoSection = targetSection.key;
        this.additionalInfoSections.forEach(el => el.isSelected = el.key === targetSection.key);
      }
      else {
        this.showFormErrorMessage();
      }
    }
  }

  validateCurrentSection(key: string): boolean | null {
    switch (key) {
      case 'cold-storage':
        return this.validateSectionFields(['fridgeStorageId']);
      case 'instructive':
        const fields = ['harvestDate', 'consigneeId', 'notifyId', 'destinationCountryId']
        if (this.programType === 0) fields.push('destinationPortId');
        else fields.push('destinationAirportId');
        return this.validateSectionFields(fields);
      case 'container':
        return this.validateSectionFields(['containerCbm', 'containerTemperature']);
      case 'assignment':
        return this.validateSectionFields(['forwarder', 'customAgent']);
      case 'observations':
        return this.directSaleFormGroup.get('observations')?.value ? true : null;
      case 'qc-review':
        return null;
      default:
        return false;
    }
  }

  validateSectionFields(fields: string[]) {
    let isValid = true;
    fields.forEach((field) => {
      if (!this.directSaleFormGroup.get(field)?.valid) {
        isValid = false;
      }
    })
    return isValid
  }

  validatePreviousSection(key: string, sections: AdditionalInfoSection[], index: number) {
    if (sections[index - 1].isValid) {
      this.selectedInfoSection = key;
      sections.forEach((el) => {el.isSelected = el.key === key})
      if (key !== 'qc-review') sections[index + 1].isAvailable = true
    }
    return sections
  }

  hasPreviousSection(): boolean {
    return this.additionalInfoSections.findIndex(el => el.key === this.selectedInfoSection) > 0;
  }

  hasNextSection(): boolean {
    return this.additionalInfoSections.findIndex(el => el.key === this.selectedInfoSection) < this.additionalInfoSections.length - 1;
  }

  goToPreviousSection(): void {
    const index = this.additionalInfoSections.findIndex(el => el.key === this.selectedInfoSection);
    const currentValid = this.validateCurrentSection(this.selectedInfoSection);
    this.additionalInfoSections[index].isValid = currentValid;

    if (currentValid === false) {
      this.showFormErrorMessage();
      return;
    }

    if (index === 0) return;

    this.selectedInfoSection = this.additionalInfoSections[index - 1].key;
    this.additionalInfoSections.forEach(el => el.isSelected = el.key === this.selectedInfoSection);
  }

  goToNextSection(): void {
    const index = this.additionalInfoSections.findIndex(el => el.key === this.selectedInfoSection);
    const currentValid = this.validateCurrentSection(this.selectedInfoSection);
    this.additionalInfoSections[index].isValid = currentValid;

    if (currentValid === false) {
      this.showFormErrorMessage();
      return;
    }

    if (index < this.additionalInfoSections.length - 1) {
      this.additionalInfoSections[index + 1].isAvailable = true;
      this.selectedInfoSection = this.additionalInfoSections[index + 1].key;
      this.additionalInfoSections.forEach(el => el.isSelected = el.key === this.selectedInfoSection);
    }
  }

  showFormErrorMessage() {
    this._messageService.add({
      severity: 'error',
      summary: this.translate.instant('UserPages.UserPurchaseOrders.VerifyPalletsPage.ErrorSectionTitle'),
      detail: this.translate.instant('UserPages.UserPurchaseOrders.VerifyPalletsPage.ErrorSectionMessage')
    });
  }

  changeIndex(index: number)
  {
    SessionVarUtils.setVerifyPalletsIndex(index);
  }



  loadDirectSaleForm() {
    if(this.detail) {
      this.directSaleFormGroup.controls['harvestDate'].setValue(this.detail.harvestDate ? new Date(this.detail.harvestDate) : null)
      this.directSaleFormGroup.controls['fridgeStorageId'].setValue(this.detail.fridgeStorageId)
      this.directSaleFormGroup.controls['readyToLoadDate'].setValue(this.detail.readyToLoadDate ? new Date(this.detail.readyToLoadDate) : null)
      if(this.detail.shelfLife){
        this.directSaleFormGroup.controls['shelfLife'].setValue(this.detail.shelfLife)
      }
    }
    if(this.dto) {
      this.directSaleFormGroup.controls['forwarder'].setValue(this.dto.forwarderCompany?.id)
      this.directSaleFormGroup.controls['customAgent'].setValue(this.dto.customAgent?.id)
      this.directSaleFormGroup.controls['containerCbm'].setValue(this.dto.containerCbm)
      this.directSaleFormGroup.controls['containerTemperature'].setValue(this.dto.containerTemperature)
      this.directSaleFormGroup.controls['observations'].setValue(this.dto.observations)
    }

  }

  getImportOrder(){
    if(this.detail){
       this._importOrderService.getById(this.detail.importOrderId).subscribe({
        next : (v) => {
          this.importOrderInfo = v
          this.programType = this.importOrderInfo.importOrder.transportType
          this.directSaleFormGroup.controls['destinationCountryId'].setValue(this.importOrderInfo.importOrder.importToCountryId)

          // Si containerCbm y containerTemperature vienen en el delivery, se toma de allí
          if (this.importOrderInfo?.delivery?.containerCbm) {
            this.directSaleFormGroup.controls['containerCbm'].setValue(this.importOrderInfo.delivery.containerCbm)
          }
          if (this.importOrderInfo?.delivery?.containerTemperature) {
            this.directSaleFormGroup.controls['containerTemperature'].setValue(this.importOrderInfo.delivery.containerTemperature)
          }
          this.getPorts()
          this.getAirPorts()

          if(this.profile?.profileType == 'Exporter') {
            this.getNotifies()
            this.getConsignees()
          }

          if(this.programType === 0)
          {
            this.directSaleFormGroup.controls['destinationPortId'].setValue(this.importOrderInfo.importOrder.portToId)
            this.directSaleFormGroup.controls['destinationPortId'].setValidators([Validators.required])
          }else{
            this.directSaleFormGroup.controls['destinationAirportId'].setValue(this.importOrderInfo.importOrder.destinationAirportId)
            this.directSaleFormGroup.controls['destinationAirportId'].setValidators([Validators.required])
          }
        },
        error: () => {
          this._messageService.add({ severity: 'error',
          summary: this.translate.instant('MessageService.Summary.FailedAction'),
          detail: 'Failed retrieving sale program'});
        }
       })
    }
  }

  getDirectSaleProgram(){
    if(this.directSaleProgramId){
      this._directaSaleProgramService.getByGuid(this.directSaleProgramId).subscribe({
        next : (v) => {
          this.directSaleProgram = v
          this.programId = this.directSaleProgram.id

          this.getConsignees()
          this.getNotifies()
        },
        error: () => {
          this._messageService.add({ severity: 'error',
          summary: this.translate.instant('MessageService.Summary.FailedAction'),
          detail: 'Failed retrieving sale program'});
        }
       })
    }
  }

  cleanPalletsConfig(){
    if(this.detail){
      this.loading = true;
      this._palletService.cleanPalletConfig(this.detail.id).subscribe({
       next: (v) => {
        this.loading = false;
        this._messageService.add({ severity: 'success',
          summary: this.translate.instant('MessageService.Summary.SuccessAction'),
          detail: this.translate.instant('MessageService.Pallet.CleanPalletConfig') })

          this.verifyDeleteConfig = false;
          this.isCreate = true;
          this.isEdit = false;
          this.generatePallets()
       },
       error: (e) => {
        this.loading = false;
        let errorMessage = ''
        switch(this.profile?.lang) {
          case 'es':
            errorMessage = e.error.messageEs
            break
          case 'en':
            errorMessage = e.error.messageEn
            break
        }
        if(e.status === 400 || e.status === 404){
          this._messageService.add({ severity: 'error', summary: this.translate.instant('MessageService.Summary.FailedAction'), detail: errorMessage });
        }
        else {
          this._messageService.add({ severity: 'error', summary: this.translate.instant('MessageService.Summary.FailedAction'), detail:this.translate.instant('MessageService.Pallet.CleanPalletsFailed') })
        }
       }
      })
    }
  }

  loadQualityControlCompany()
  {

    if(this.detail){
      this.loading = true
      this._qualityControlService.getAllByOperationCountryId(this.detail.exportOfferCountryId).subscribe({
        next: (v) => {
          this.qcCompanies = v;
          this.qcCompanies.push(this.noQCCompany);
          this.assignQcCompany()
          this.loading = false
        },
        error: (e) => {
          this.loading = false
          this._messageService.add({ severity: 'error',
            summary: this.translate.instant('MessageService.Summary.FailedAction'),
            detail: this.translate.instant('MessageService.Country.ManyRetrieveError') })
        },
      })
    }
  }

  assignQcCompany(){
    if(this.detail && this.qcCompanies)
    {
      var qcSelected = this.qcCompanies.find( x => x.id == this.detail?.qcCompanyId )
      if(qcSelected)
      {
        this.itemQCSelected = qcSelected;
        this.companySpeciesSelected = qcSelected.qualityControlCompanySpecies ? qcSelected.qualityControlCompanySpecies : [] ;
      }
    }
  }

  setQcBefore()
  {
    if(this.detail && this.qcCompanies)
      {
        var qcSelected = this.qcCompanies.find( x => x.id == this.itemBeforeSelect?.id )
        if(qcSelected)
        {
          this.itemQCSelected = qcSelected;
          this.companySpeciesSelected = qcSelected.qualityControlCompanySpecies ? qcSelected.qualityControlCompanySpecies : [] ;
        }
      }
  }


  loadCountries() {
    this.countries = []
    this.loading = true
    this._countryService.getAll().subscribe({
      next: (v) => {
        this.countries = v
        this.loading = false

      },
      error: (e) => {
        console.log(e)
        this.loading = false
        this._messageService.add({ severity: 'error',
          summary: this.translate.instant('MessageService.Summary.FailedAction'),
          detail: this.translate.instant('MessageService.Country.ManyRetrieveError') })
      },
      complete: () => console.info('Country query successfully')
    })
  }

  getImageUrl(url?: string): string {
    if(url){
      //return environment.apiUrl + url
      return url
    }else{
      return  ''
    }

  }

  getPriceConfiguration()
  {
    this.palletsPrice = []
    if(this.detail)
      {
        this.loading = true
        this._palletService.getPalletPriceConfiguration(this.detail.id).subscribe({
          next: (v) => {
            this.currentPrices = v
            this.loading = false
          },
          error: (e) => {
            this.loading = false
            this._messageService.add({
              severity: 'error',
              summary: this.translate.instant('MessageService.Summary.FailedAction'),
              detail: e.message
            })
          }
        })

      }
  }

  getFridgeStorages() {
    this.fridgeStorages = []
    this.loading = true
    this._fridgeStorageService.getAllByStorageType(1).subscribe({
      next: (v) => {
        this.fridgeStorages = v
        this.loading = false
        this.fridgeStorages.push({
          id: 0,
          label: this.translate.instant('MessageService.FridgeStorage.CreateOptionLabel') + '...'
        })

        this.fridgeStorageOptions = this.fridgeStorages.map((item) => {
          return {
            ...item,
            label: item.label ?? item.name + ', ' + item.contactAddress + ' - ' +  item.contactCountry?.name
          }
        })
      },
      error: (e) => {
        console.log(e)
        this.loading = false
        this._messageService.add({ severity: 'error',
          summary: this.translate.instant('MessageService.Summary.FailedAction'),
          detail: this.translate.instant('MessageService.FridgeStorage.ManyRetrieveError') })
      },
      complete: () => console.info('Fridge Storage query successfully')
    })
  }

  onChangeFridgestorage() {
    const selected = this.directSaleFormGroup.controls['fridgeStorageId'].value
    if(selected === 0) {
      this.openNewFridgestorageDialog()
    }
    this.validateCurrentSection('cold-storage')
  }

  openNewFridgestorageDialog() {
    this.fridgestorageFormGroup.controls["fridgestorageName"].setValue(''),
    this.fridgestorageFormGroup.controls["fridgestorageVat"].setValue(''),
    this.fridgestorageFormGroup.controls["fridgestorageContactName"].setValue(''),
    this.fridgestorageFormGroup.controls["fridgestorageContactAddress"].setValue(''),
    this.fridgestorageFormGroup.controls["fridgestorageContactEmail"].setValue(''),
    this.fridgestorageFormGroup.controls["fridgestorageContactPhone"].setValue(''),
    this.fridgestorageFormGroup.controls["fridgestorageContactCity"].setValue(''),
    this.fridgestorageFormGroup.controls["fridgestorageContactCountryId"].setValue('')
    this.fridgestorageFormGroup.controls["fridgestorageFDA"].setValue('')
    this.loadFridgestorageDialogVisible = true
  }

  saveFridgestorage() {
    this.submit = true
    this.loading = true
    if(this.fridgestorageFormGroup.valid) {
      const newFridgeStorage: NewFridgeStorage = {
        name: this.fridgestorageFormGroup.controls["fridgestorageName"].value,
        vat: this.fridgestorageFormGroup.controls["fridgestorageVat"].value,
        contactName: this.fridgestorageFormGroup.controls["fridgestorageContactName"].value,
        contactAddress: this.fridgestorageFormGroup.controls["fridgestorageContactAddress"].value,
        contactEmail: this.fridgestorageFormGroup.controls["fridgestorageContactEmail"].value,
        contactPhone: this.fridgestorageFormGroup.controls["fridgestorageContactPhone"].value,
        contactCity: this.fridgestorageFormGroup.controls["fridgestorageContactCity"].value,
        contactCountryId: this.fridgestorageFormGroup.controls["fridgestorageContactCountryId"].value,
        FDA: this.fridgestorageFormGroup.controls["fridgestorageFDA"].value,
        storageType: 1
      }

      this._fridgeStorageService.create(newFridgeStorage).subscribe({
        next: (v) => {
          this.getFridgeStorages()
          this.loadFridgestorageDialogVisible = false
          this._messageService.add({ severity: 'success',
            summary: this.translate.instant('MessageService.Summary.SuccessAction'),
            detail: this.translate.instant('MessageService.FridgeStorage.CreateSuccess') })
          this.loading = false
          this.submit = false
        },
        error: (e) => {
          this.loading = false
          this.submit = false
          console.log(e)
          this._messageService.add({ severity: 'error',
            summary: this.translate.instant('MessageService.Summary.FailedAction'),
            detail: this.translate.instant('MessageService.FridgeStorage.CreateError') });
        },
        complete: () =>  {
          this.loading = false
          this.submit = false
          console.info('FridgeStorage created successfully')
        }
      })
    }
    else {
      this.loading = false
    }
  }

  confirmPalletPrice()
  {
    if(this.palletsPrice && this.detail){
      let createPalletPriceRequest: CreatePalletPriceRequest  = {
        importOrderDetailId: this.detail.id,
        palletPriceConfig: this.palletsPrice,
        withProducer: this.withProducer
      }
      this._palletService.createPalletPrice(createPalletPriceRequest).subscribe({
        next: (v) => {
          this._messageService.add({
            severity: 'success',
            summary: 'Confirmado',
            detail: 'Configuración de precios realizada exitosamente'
          })
          this.getPriceConfiguration()
        },
        error: (e) =>
        {
          this._messageService.add({
            severity: 'success',
            summary: 'Error',
            detail: 'Error al intentar guardar configuración de precios'
          })
        }
      })
    }

    this.visiblePalletsPrice = false
  }

  generatePallets(rowsNumber?: number) {

    this.pallets = []
    if(this.detail) {

      let rowsLength = rowsNumber ? rowsNumber: this.detail.palletsQuantity;
      for(let i = 0; i < rowsLength; i++) {
        this.pallets.push({
          dataKey: i,
          palletNumber: '',
          palletTypeId: 1
        })
      }
    }
  }

  showDialog() {
    this.excelFile = null
    this.excelSheets = null
    this.startRow = 1
    this.folioColumn = ''
    this.caliberColumn = ''
    this.producerColumn = ''
    this.tabActiveIndex = 0;
    this.loadPalletsStep = 1;
    this.copyPasteExcelService.setIsDisplayTable(false);
    this.copyPasteExcelService.setIsClearTextArea();
    this.palletFormGroup.controls['endRow'].setValue(null)

    if(this.isEdit)
    {
      this.verifyDeleteConfig = true
    }else{
      this.visibleLoadInformation = true
    }
  }

  showDialogLatam() {

    if(this.latamPallet.length === 0) {
      this.addNewLine()
    }
    this.visibleLatamLoad = true

  }

  addNewLine(){
    if(this.detail)
      {
      if(this.profile?.lang === 'es'){
        this.defaultLoadPallet.specieName = this.detail.speciesNameEs;
      }else{
        this.defaultLoadPallet.specieName = this.detail.speciesNameEn;
      }
      this.defaultLoadPallet.varietyName = this.detail.varietyName;
      this.defaultLoadPallet.speciesSize = this.detail.speciesSize ?? '';
      this.defaultLoadPallet.category = this.detail.category ?? '';
      this.defaultLoadPallet.pallets = this.detail.palletQuantity  ?? 20;
      this.defaultLoadPallet.boxes = this.detail.boxesQuantity;
      let newLine: LatamPalletDto = {...this.defaultLoadPallet}
      this.latamPallet.push(newLine);
    }
  }

  deleteLine(index: number)
  {
    // this.latamPallet = [...this.latamPallet.slice(index, index)];
    this.latamPallet.splice(index, 1)
  }

  showMoreInfo(loadPallet: LatamPalletDto, index: number)
  {
    this.selectedDefaultPallet = loadPallet
    this.selectedPalletIndex = index

    this.latamPalletForm.controls['csp'].setValue(loadPallet.csp);
    this.latamPalletForm.controls['csg'].setValue(loadPallet.csp);
    if(loadPallet.excelImportHarvestDate){
      this.latamPalletForm.controls['harvestDate'].setValue(new Date(loadPallet.excelImportHarvestDate));
    }

    if(loadPallet.excelImportQualityControlDate){
      this.latamPalletForm.controls['qualityControlDate'].setValue(new Date(loadPallet.excelImportQualityControlDate));
    }
    this.latamPalletForm.controls['packaging'].setValue(loadPallet.excelImportPackaging);
    this.latamPalletForm.controls['palletType'].setValue(loadPallet.excelImportPalletType);
    this.latamPalletForm.controls['tag'].setValue(loadPallet.excelImportTag);
    this.latamPalletForm.controls['bagType'].setValue(loadPallet.excelImportBagType);
    this.latamPalletForm.controls['boxSize'].setValue(loadPallet.excelImportBoxSize);
    this.latamPalletForm.controls['mark'].setValue(loadPallet.excelImportMark);

    this.visibleMoreInfo = true
  }

  saveLatamInfo()
  {
    if(this.selectedDefaultPallet)
    {
      this.selectedDefaultPallet.csp = this.latamPalletForm.controls['csp'].value;
      this.selectedDefaultPallet.csg = this.latamPalletForm.controls['csg'].value;

      if(this.latamPalletForm.controls['harvestDate'].value instanceof Date)
      {
        this.selectedDefaultPallet.excelImportHarvestDate = new Date(this.latamPalletForm.controls['harvestDate'].value).toLocaleDateString('es-ES');
      }

      if( this.latamPalletForm.controls['qualityControlDate'].value instanceof Date)
      {
        this.selectedDefaultPallet.excelImportQualityControlDate = new Date(this.latamPalletForm.controls['qualityControlDate'].value).toLocaleDateString('es-ES');
      }
      this.selectedDefaultPallet.excelImportPackaging = this.latamPalletForm.controls['packaging'].value;
      this.selectedDefaultPallet.excelImportPalletType = this.latamPalletForm.controls['palletType'].value;
      this.selectedDefaultPallet.excelImportTag = this.latamPalletForm.controls['tag'].value;
      this.selectedDefaultPallet.excelImportBagType = this.latamPalletForm.controls['bagType'].value;
      this.selectedDefaultPallet.excelImportBoxSize = this.latamPalletForm.controls['boxSize'].value;
      this.selectedDefaultPallet.excelImportMark = this.latamPalletForm.controls['mark'].value;
      this.latamPallet[this.selectedPalletIndex] = this.selectedDefaultPallet;
    }

    this.visibleMoreInfo = false;
  }


  onSelectExcelFile(uploader: any) {
    this.excelFile = uploader.files[0]
    readSheetNames(uploader.files[0]).catch( error => {
      console.log('error');
      this._messageService.add({
        severity: 'error',
        summary: this.translate.instant('MessageService.Excel.FailedAction'),
        detail: this.translate.instant('UserPages.UserPurchaseOrders.VerifyPalletsPage.LoadExcelModal.FormatExcelMessage')
      })

      this.loading = false

    }).then((sheetNames) => {
      this.excelSheets = sheetNames
    })

    uploader.clear()
  }

  padWithLeadingZeros(id: number): string {
    return OrderUtils.padWithLeadingZeros(id)
  }

  onLoadExcel2(isLoadFromFile?: boolean)
  {
    this.loading = true
    if(this.palletFormGroup.valid) {
      if(!this.excelFile)
        return

      if(!this.selectedSheet)
        return

      let startRow = this.palletFormGroup.controls['startRow'].value
      let endRow = this.palletFormGroup.controls['endRow'].value

      if (isLoadFromFile && !endRow) {
        this.generatePallets()
      }
      if(endRow)
      {
        let rowNumber = endRow - startRow + 1;
        this.generatePallets(rowNumber)
      }

        readXlsxFile(this.excelFile, {sheet: this.selectedSheet}).catch( error => {
          this._messageService.add({
            severity: 'error',
            summary: this.translate.instant('MessageService.Excel.FailedAction'),
            detail: this.translate.instant('UserPages.UserPurchaseOrders.VerifyPalletsPage.LoadExcelModal.FormatExcelMessage')
          })

          this.loading = false

        }).then((rows) => {
          if(rows) {
            this.pallets.forEach(pallet => {
              if(this.isCreate || this.isClosedSale) {
                pallet.palletNumber = ''
              }
              pallet.excelImportSpecies = ''
              pallet.excelImportVariety = ''
              pallet.speciesSize = ''
              pallet.category = ''
              pallet.producer = ''
              pallet.csp = ''
              pallet.csg = ''
              pallet.excelImportHarvestDate = ''
              pallet.excelImportQualityControlDate = ''
              pallet.excelImportPackaging = ''
              pallet.excelImportPalletType = ''
              pallet.excelImportTag = ''
              pallet.excelImportBagType = ''
              pallet.excelImportBoxSize = ''
              pallet.excelImportNetWeight = ''
              pallet.excelImportFridgeStorage = ''
              pallet.excelImportBoxesPerPallet = ''
              pallet.excelImportMark = ''
              pallet.excelImportContainerNumber = ''
              pallet.excelImportGrade = ''
              pallet.excelImportTemptale = ''
              pallet.excelImportOriginCountry = ''
              pallet.excelImportCertificate1 = ''
              pallet.excelImportCertificate2 = ''
              pallet.excelImportCertificate3 = ''
              pallet.excelImportLoadWeek = ''
            })

          rows.forEach(row => {
            for(let k=0; k < row.length; k++) {
              if(row[k]) {
                let value = row[k]
                if(value instanceof Date) {
                  value.setDate(value.getDate() + 1)
                  value = moment(value).format('DD/MM/YYYY')
                }
                else if (value) {
                  value = value.toString()
                }
                row[k] = value
              }
            }
          })


          let folioColumn = this.palletFormGroup.controls['folioColumn'].value
          let speciesColumn = this.palletFormGroup.controls['speciesColumn'].value
          let categoryColumn = this.palletFormGroup.controls['categoryColumn'].value
          let varietyColumn = this.palletFormGroup.controls['varietyColumn'].value
          let producerColumn = this.palletFormGroup.controls['producerColumn'].value
          let cspColumn = this.palletFormGroup.controls['cspColumn'].value
          let csgColumn = this.palletFormGroup.controls['csgColumn'].value
          let speciesSizeColumn = this.palletFormGroup.controls['speciesSizeColumn'].value
          let harvestDateColumn = this.palletFormGroup.controls['harvestDateColumn'].value
          let qualityControlDateColumn = this.palletFormGroup.controls['qualityControlDateColumn'].value
          let packagingColumn = this.palletFormGroup.controls['packagingColumn'].value
          let palletTypeColumn = this.palletFormGroup.controls['palletTypeColumn'].value
          let tagColumn = this.palletFormGroup.controls['tagColumn'].value
          let bagTypeColumn = this.palletFormGroup.controls['bagTypeColumn'].value
          let boxSizeColumn = this.palletFormGroup.controls['boxSizeColumn'].value
          let netWeightColumn = this.palletFormGroup.controls['netWeightColumn'].value
          let fridgeStorageColumn = this.palletFormGroup.controls['fridgeStorageColumn'].value
          let boxesPerPalletColumn = this.palletFormGroup.controls['boxesPerPalletColumn'].value
          let markColumn = this.palletFormGroup.controls['markColumn'].value
          // let containerNumberColumn = this.palletFormGroup.controls['containerNumberColumn'].value
          let temptaleColumn = this.palletFormGroup.controls['temptaleColumn'].value
          let originCountryColumn = this.palletFormGroup.controls['originCountryColumn'].value
          let gradeColumn = this.palletFormGroup.controls['gradeColumn'].value
          // let certificate1Column = this.palletFormGroup.controls['certificate1Column'].value
          // let certificate2Column = this.palletFormGroup.controls['certificate2Column'].value
          // let certificate3Column = this.palletFormGroup.controls['certificate3Column'].value
          // let loadWeekColumn = this.palletFormGroup.controls['loadWeekColumn'].value

          const rowStartIndex = startRow - 1
          let j = 0

          let cellValue = (row: any, column: any, pallet: any, property: string) => {
            if(column) {
              const index =  this.columns.indexOf(column.toUpperCase())
              pallet[property] = row[index] ? row[index].toString() : ''
            }
          }

          for(let i = rowStartIndex; i < rows.length; i++) {
            const row = rows[i]
            let pallet = this.pallets[j]
            if(pallet) {

              if(this.isCreate || this.isClosedSale) {
                cellValue(row, folioColumn, pallet, 'palletNumber')
              }
              cellValue(row, speciesColumn, pallet, 'excelImportSpecies')
              cellValue(row, varietyColumn, pallet, 'excelImportVariety')
              cellValue(row, producerColumn, pallet, 'producer')
              cellValue(row, cspColumn, pallet, 'csp')
              cellValue(row, csgColumn, pallet, 'csg')
              cellValue(row, speciesSizeColumn, pallet, 'speciesSize')
              cellValue(row, categoryColumn, pallet, 'category')
              cellValue(row, harvestDateColumn, pallet, 'excelImportHarvestDate')
              cellValue(row, qualityControlDateColumn, pallet, 'excelImportQualityControlDate')
              cellValue(row, packagingColumn, pallet, 'excelImportPackaging')
              cellValue(row, palletTypeColumn, pallet, 'excelImportPalletType')
              cellValue(row, tagColumn, pallet, 'excelImportTag')
              cellValue(row, bagTypeColumn, pallet, 'excelImportBagType')
              cellValue(row, boxSizeColumn, pallet, 'excelImportBoxSize')
              cellValue(row, netWeightColumn, pallet, 'excelImportNetWeight')
              //cellValue(row, fridgeStorageColumn, pallet, 'excelImportFridgeStorage')
              pallet.excelImportFridgeStorage = this.detail?.fridgeStorageName
              cellValue(row, boxesPerPalletColumn, pallet, 'excelImportBoxesPerPallet')
              cellValue(row, markColumn, pallet, 'excelImportMark')
              // cellValue(row, containerNumberColumn, pallet, 'excelImportContainerNumber')
              cellValue(row, temptaleColumn, pallet, 'excelImportTemptale')
              cellValue(row, originCountryColumn, pallet, 'excelImportOriginCountry')
              cellValue(row, gradeColumn, pallet, 'excelImportGrade')
              // cellValue(row, certificate1Column, pallet, 'excelImportCertificate1')
              // cellValue(row, certificate2Column, pallet, 'excelImportCertificate2')
              // cellValue(row, certificate3Column, pallet, 'excelImportCertificate3')
              // cellValue(row, loadWeekColumn, pallet, 'excelImportLoadWeek')

            }
            j++
          }
        }

        if(this.isClosedSale)
          {
            this.calculateTablePrice()
            this.showPalletPriceModal()
            this.readFile = true;

          }
      })
      this.onCloseLoadInformationDialog();
      this.tabActiveIndex = 0;
      this.loading = false
    } else {
      this.loading = false
    }
  }

  save() {
    if(this.isClosedSale) {
      this.saveClosedSale()
    }
    else {
      this.saveMarketplaceSale()
    }
  }

  calculateTablePrice()
  {
    this.palletsPrice = []
    if(this.detail){
      this.loading = true
      this._palletService.getPalletPriceConfigurationFromArray(this.pallets, this.withProducer).subscribe({
        next: (v) => {
          this.palletsPrice = v
          this.loading = false
          this.visiblePalletsPrice = true
        },
        error: (e) => {
          this.loading = false
          this._messageService.add({
            severity: 'error',
            summary: this.translate.instant('MessageService.Summary.FailedAction'),
            detail: e.message
          })
        }
      })
    }
  }

  saveMarketplaceSale() {
    this.submit = true
    this.loading = true
    if(this.detail) {

      if(!this.isValidDatatable()) {
        this.loading = false
        return
      }

      const request: CreatePalletsRequest = {
        pallets: this.pallets,
        importOrderDetailId: this.detail.id,
        destinationQCCompanyId: this.selectedDestinationQCCompany?.id,
        containerCbm: this.directSaleFormGroup.controls['containerCbm'].value,
        containerTemperature: this.directSaleFormGroup.controls['containerTemperature'].value,
      }

      if(this.isEdit) {
        this._palletService.update(request).subscribe({
          next: (v) => {
            this._messageService.add({ severity: 'success',
              summary: this.translate.instant('MessageService.Summary.SuccessAction'),
              detail: this.translate.instant('MessageService.Pallet.EditSuccess') })
            this.success = true
            this.submit = false
            this.loading = false
          },
          error: (e) => {
            console.log(e)
            this.success = false
            this.submit = false
            this.loading = false
            // let errorMessage = ''
            // switch(this.profile?.lang) {
            //   case 'es':
            //     errorMessage = e.error.messageEs
            //     break
            //   case 'en':
            //     errorMessage = e.error.messageEn
            //     break
            // }
            this._messageService.add({ severity: 'error',
              summary: this.translate.instant('MessageService.Summary.FailedAction'),
              detail: ErrorMessageUtil.getResponseError(e.error,this.profile?.lang, this.translate.instant('MessageService.Pallet.EditError') ) })
          },
          complete: () => console.info('Pallets updated successfully')
        })
      }
      else {
        this._palletService.Create(request).subscribe({
          next: (v) => {
            this._messageService.add({ severity: 'success',
              summary: this.translate.instant('MessageService.Summary.SuccessAction'),
              detail: this.translate.instant('MessageService.Pallet.CreateSuccess') })
            this.success = true
            this.submit = false
            this.loading = false
          },
          error: (e) => {
            console.log(e)
            this.success = false
            this.submit = false
            this.loading = false
            let errorMessage = ''
            switch(this.profile?.lang) {
              case 'es':
                errorMessage = e.error.messageEs
                break
              case 'en':
                errorMessage = e.error.messageEn
                break
            }
            this._messageService.add({ severity: 'error',
              summary: this.translate.instant('MessageService.Summary.FailedAction'),
              detail: ErrorMessageUtil.getResponseError(e.error,this.profile?.lang,  this.translate.instant('MessageService.Pallet.CreateError') )}
            )
          },
          complete: () => console.info('Pallets created successfully')
        })
      }
    }
    else {
      this.loading = false
    }
  }

  get totalBoxesPallets(): number
  {
    var total = 0
    if(this.palletsPrice){
      this.palletsPrice.forEach( x => {
        total += x.boxPerPallets;
      })
    }

    return total
  }

  get totalBoxesPalletsCurrent(): number
  {
    var total = 0
    if(this.currentPrices){
      this.currentPrices.forEach( x => {
        total += x.boxPerPallets;
      })
    }

    return total
  }

  get uniquePalletsRead(): number {
    var uniquePallets:string[] = [];

    if(this.readFile){
      if(this.pallets){

        this.pallets.forEach( x => {
           var index = uniquePallets.findIndex(element => element === x.palletNumber
           )

           if(index === -1){
            uniquePallets.push(x.palletNumber);
           }
        })
      }
    }
    return uniquePallets.length;
  }

  saveClosedSale() {
    this.submit = true
    this.loading = true
    if(this.detail) {
      if(this.directSaleFormGroup.valid) {
        if(!this.isValidDatatable()) {
          this.loading = false
          return
        }

        const request: CreatePalletsRequest = {
          pallets: this.pallets,
          importOrderDetailId: this.detail.id,
          originQCCompanyId: this.selectedOriginQCCompany?.id,
          fridgeStorageId: this.directSaleFormGroup.controls['fridgeStorageId'].value,
          harvestDate: this.directSaleFormGroup.controls['harvestDate'].value,
          shelfLife: this.directSaleFormGroup.controls['shelfLife'].value,
          readyToLoadDate: this.directSaleFormGroup.controls['readyToLoadDate'].value,
          forwarderCompanyId: this.directSaleFormGroup.controls['forwarder'].value,
          customAgentCompanyId: this.directSaleFormGroup.controls['customAgent'].value,
          observations: this.directSaleFormGroup.controls['observations'].value,
          containerCbm: this.directSaleFormGroup.controls['containerCbm'].value,
          containerTemperature: this.directSaleFormGroup.controls['containerTemperature'].value,
          notifyId: this.directSaleFormGroup.controls['notifyId'].value,
          consigneeId: this.directSaleFormGroup.controls['consigneeId'].value,
          destinationPortId: this.directSaleFormGroup.controls['destinationPortId'].value,
          destinationAirportId: this.directSaleFormGroup.controls['destinationAirportId'].value
        }

        if(this.isEdit) {
          this._palletService.update(request).subscribe({
            next: (v) => {
              this._messageService.add({ severity: 'success',
                summary: this.translate.instant('MessageService.Summary.SuccessAction'),
                detail: this.translate.instant('MessageService.Pallet.EditSuccess') })
              this.success = true
              this.submit = false
              this.loading = false
            },
            error: (e) => {
              console.log(e)
              this.success = false
              this.submit = false
              this.loading = false
            this._messageService.add({ severity: 'error',
              summary: this.translate.instant('MessageService.Summary.FailedAction'),
              detail: ErrorMessageUtil.getResponseError(e.error,this.profile?.lang, this.translate.instant('MessageService.Pallet.EditError') ) })
            },
            complete: () => console.info('Pallets updated successfully')
          })

        }
        else {
          this._palletService.createClosedSale(request).subscribe({
            next: (v) => {
              this._messageService.add({ severity: 'success',
                summary: this.translate.instant('MessageService.Summary.SuccessAction'),
                detail: this.translate.instant('MessageService.Pallet.CreateSuccess') })
              this.success = true
              this.submit = false
              this.loading = false
            },
            error: (e) => {
              console.log(e)
              this.success = false
              this.submit = false
              this.loading = false
              this._messageService.add({ severity: 'error',
                summary: this.translate.instant('MessageService.Summary.FailedAction'),
                detail: ErrorMessageUtil.getResponseError(e.error,this.profile?.lang,  this.translate.instant('MessageService.Pallet.CreateError') ) })
            },
            complete: () => console.info('Pallets created successfully')
          })
        }
      }
      else {
        this._messageService.add({ severity: 'error',
          summary: this.translate.instant('MessageService.Summary.FailedAction'),
          detail: this.translate.instant('MessageService.FormMessages.FormInvalid') })
        this.loading = false
      }
    }
    else {
      this.loading = false
    }
  }

  private isValidDatatable(): boolean {
    let isValid = true

    if(!this.pallets)
      return false

    this.pallets.forEach(x => {
      if(!x.palletNumber || x.palletNumber.length < 1) {
        isValid = false
        this._messageService.add({ severity: 'error',
          summary: this.translate.instant('MessageService.Summary.FailedAction'),
          detail: this.translate.instant('MessageService.Pallet.IncompletePalletNumbersError') })
        return
      }

      if(!x.excelImportSpecies || x.excelImportSpecies.length < 1) {
        isValid = false
        this._messageService.add({ severity: 'error',
          summary: this.translate.instant('MessageService.Summary.FailedAction'),
          detail: this.translate.instant('MessageService.Pallet.IncompleteSpeciesError') })
        return
      }

      if(!x.excelImportVariety || x.excelImportVariety.length < 1) {
        isValid = false
        this._messageService.add({ severity: 'error',
          summary: this.translate.instant('MessageService.Summary.FailedAction'),
          detail: this.translate.instant('MessageService.Pallet.IncompleteVarietyError') })
        return
      }

      if(!x.producer || x.producer.length < 1) {
        isValid = false
        this._messageService.add({ severity: 'error',
          summary: this.translate.instant('MessageService.Summary.FailedAction'),
          detail: this.translate.instant('MessageService.Pallet.IncompleteProducerError') })
        return
      }

      if(!isValid) return
    })

    return isValid
  }

  showPalletPriceModal() {
    if(this.isClosedSale){
      this.calculateTablePrice()
    }

  }

  showCurrentPalletPriceModal() {
    if(this.isClosedSale){
      this.visibleCurrentPalletsPrice = true
    }
  }

  onCancelNewFridgestorage() {
    this.directSaleFormGroup.controls['fridgeStorageId'].setValue(null)
    this.loadFridgestorageDialogVisible = false
    this.submit = false
    this.loading = false
  }

  onCancel() {
    if(this.detail) {
      if(this.isClosedSale) {
        this._router.navigate(['/' + Routes.exporterClosedSaleOrdersPage, this.directSaleProgramId])
      }
      else {
        this._router.navigate(['/' + Routes.userOrderDetailPage, this.detail.importOrderId])
      }
    }
  }

  onAccept() {
    if (this.detail) {
      this._router.navigate(['/' + Routes.qcOrderDetailPage, this.detail.id])
    }
  }

  getErrorMessage(formGroup: FormGroup, fieldName: string): string {
    return ErrorMessageUtil.getErrorMessage(formGroup, this.translate, fieldName)
  }

  getDirectSaleErrorMessage(formGroup: FormGroup, fieldName: string): string {
    const formField = formGroup.controls[fieldName];
    if (formField.hasError('required') && formField.touched) {
      return this.translate.instant('FormErrorMessage.FieldValueRequired')
    }
    return '';
  }

  goToImportOrderPage() {
    if(this.detail) {
      this._router.navigate(['/' + Routes.userOrderDetailPage, this.detail.importOrderId])
    }
  }

  getSpeciesName(species: Species | undefined): string {
    if(this.profile)
      return SpeciesUtils.getSpeciesName(this.profile.lang, species)
    return ''
  }

  viewOriginQCReviewDocument(review: QualityControlReview) {
    if(review.typeUpload == 0)
    {
      this._documentService.getOriginQCReviewDocument(review.guid).subscribe((resultBlob: any) => {
      const downloadURL = window.URL.createObjectURL(resultBlob.body);
      window.open(downloadURL);})
    }else
    {
        if(review.reviewGuid)
        {
          this._documentService.getOperationDocument(review.reviewGuid).subscribe((resultBlob: any) => {
          const downloadURL = window.URL.createObjectURL(resultBlob.body);
          window.open(downloadURL);})
        }
    }

  }

  viewOriginQCConsolidationDocument(review: QualityControlReview) {

    if(review.typeUpload == 0)
      {
      this._documentService.getOriginQCConsolidationDocument(review.guid).subscribe((resultBlob: any) => {
        const downloadURL = window.URL.createObjectURL(resultBlob.body);
        window.open(downloadURL);})
      }else
      {
        if(review.consolidationGuid)
        {
          this._documentService.getOperationDocument(review.consolidationGuid).subscribe((resultBlob: any) => {
          const downloadURL = window.URL.createObjectURL(resultBlob.body);
          window.open(downloadURL);})
        }
      }
    }


  viewOriginQCArrivalDocument(review: QualityControlReview) {
        console.log(review)
    if(review.typeUpload == 0)
    {
      this._documentService.getOriginQCArrivalDocument(review.guid).subscribe((resultBlob: any) => {
      const downloadURL = window.URL.createObjectURL(resultBlob.body);
      window.open(downloadURL);})
    }
    else
    {
      if(review.reviewArrivalGuid)
      {
        this._documentService.getOperationDocument(review.reviewArrivalGuid).subscribe((resultBlob: any) => {
        const downloadURL = window.URL.createObjectURL(resultBlob.body);
        window.open(downloadURL);})
      }
    }

  }

  viewOriginQCSurveyDocument(review: QualityControlReview) {
    if(review.typeUpload == 0)
    {
      this._documentService.getOriginQCSurveyReportDocument(review.guid).subscribe((resultBlob: any) => {
      const downloadURL = window.URL.createObjectURL(resultBlob.body);
      window.open(downloadURL);})
    }
    else
    {
      if(review.surveyReportGuid)
      {
        this._documentService.getOperationDocument(review.surveyReportGuid).subscribe((resultBlob: any) => {
        const downloadURL = window.URL.createObjectURL(resultBlob.body);
        window.open(downloadURL);})
      }
    }

  }

  get showTypeOrderLabel(): string {
    if (this.profile?.type === 1) return 'UserPages.UserPurchaseOrders.VerifyPalletsPage.ImportOrderSequenceExportLabel'
    return 'UserPages.UserPurchaseOrders.VerifyPalletsPage.ImportOrderSequenceLabel'
  }

  get showTypeOrderDetailLabel(): string {
    if (this.profile?.type === 1) return 'UserPages.UserPurchaseOrders.VerifyPalletsPage.ImportOrderDetailSequenceExportLabel'
    return 'UserPages.UserPurchaseOrders.VerifyPalletsPage.ImportOrderDetailSequenceLabel'
  }

  getLabelsOrder() {
    if(this.profile?.profileType == 'Exporter') {
      this.orderType = 'Export'
    }
  }


  withoutNOQC() {
    this.visibleDisclaimerQCDialog = false
    this.loading = true;

    if(this.detail){
      this._importDetailService.removeQcPayment( this.detail.id).subscribe({
        next: (v) => {
          this.loading = false
          this._messageService.add({ severity: 'success',
            summary: this.translate.instant('MessageService.Summary.SuccessAction'),
            detail: this.translate.instant('MessageService.QualityControlPayment.UpdateQcCompanySuccess') })
            window.location.reload()
        },
        error: (e) => {
          this.loading = false;
          this._messageService.add({ severity: 'error',
            summary: this.translate.instant('MessageService.Summary.FailedAction'),
            detail: this.translate.instant('MessageService.QualityControlPayment.UpdateQcCompanyError') })
            this.itemBeforeSelect = this.itemQCSelected;
        }
      })
    }
  }

  withNOQC() {
    this.visibleDisclaimerQCDialog = false
    this.setQcBefore()
  }

  showSelectQCCompany() {
    this.visibleQCCompany = true
  }


  onQCCompanyTableRowSelect(event: any) {
    this.itemBeforeSelect = this.itemQCSelected;
    if(this.detail){

      //Si selecciona NOQC
      if (event.data.id == 0 && event.data.profileId == 0) {
        this.visibleQCCompany = false
        this.visibleDisclaimerQCDialog = true
        this.companySpeciesSelected = [];
      }
      else
      {
        const company = event.data
        this.itemQCSelected = company

        var request: UpdateControlCompanyRequest = {
          importOrderDetailGuId: this.detail.id,
          qualityControlCompanyId: company.id
        }


        this.loading = true;
        this._importDetailService.updateQcCompany(request).subscribe({
          next: (v) => {
            this.companySpeciesSelected = company.qualityControlCompanySpecies;
            this.visibleQCCompany = false
            this.loading = false
            this._messageService.add({ severity: 'success',
              summary: this.translate.instant('MessageService.Summary.SuccessAction'),
              detail: this.translate.instant('MessageService.QualityControlPayment.UpdateQcCompanySuccess') })
          },
          error: (e) => {
            this.loading = false;
            this._messageService.add({ severity: 'error',
              summary: this.translate.instant('MessageService.Summary.FailedAction'),
              detail: this.translate.instant('MessageService.QualityControlPayment.UpdateQcCompanyError') })
              this.itemBeforeSelect = this.itemQCSelected;
          }
        })
      }
    }
  }


  loadCompanies(type: number) {
    this.loading = true
    this._companyService.getAllByCompanyType(type).subscribe({
      next: (v) => {
        if (type === 0) this.companyForwarders = v
        if (type === 1) this.companyCustomAgents = v
        this.loading = true
      },
      error: (e) => {
        console.log(e)
        let erroMessage = ''
        if (type === 0) erroMessage = this.translate.instant('ForwarderPage.Messages.ErrorLoadForwarders')
        if (type === 1) erroMessage = this.translate.instant('CustomAgentPage.Messages.ErrorLoadCustomAgents')
        this._messageService.add({ severity: 'error', summary: this.translate.instant('MessageService.Summary.FailedAction'), detail: erroMessage });
      },
      complete: () =>  {
        this.loading = false
        console.info('Company query successfully')
      }
    })
  }

  getConsignees() {
    this.loading = true
    if(this.importOrderInfo) {
      this._consigneeService.getAllForClosedSale(this.importOrderInfo.importOrder.importerId).subscribe({
        next: (v) => {
          this.consignees = v
          this.loading = false

          if(this.importOrderInfo){
            this.directSaleFormGroup.controls['consigneeId'].setValue(this.importOrderInfo.delivery?.consigneeId)
          }
        },
        error: (e) => {
          console.log(e)
          this.loading = false
          this._messageService.add({ severity: 'error',
            summary: this.translate.instant('MessageService.Summary.FailedAction'),
            detail: this.translate.instant('MessageService.Consignee.ManyRetrieveError') })
        },
        complete: () => console.info('Consignees query successfully')
      })
    }
  }

  getNotifies() {
     this.loading = true
    if(this.importOrderInfo)
    {
      this._notifyService.getAllForClosedSale(this.importOrderInfo.importOrder.importerId).subscribe({
        next: (v) => {
          this.notifies = v
          this.loading = false

          if(this.importOrderInfo){
            this.directSaleFormGroup.controls['notifyId'].setValue(this.importOrderInfo.delivery?.notifierId)
          }

        },
        error: (e) => {
          this.loading = false
          this._messageService.add({ severity: 'error',
            summary: this.translate.instant('MessageService.Summary.FailedAction'),
            detail: this.translate.instant('MessageService.Notify.ManyRetrieveError') })
        },
        complete: () => console.info('Notifies query successfully')
      })
    }
  }

  getPorts()
  {
    this.loading = true
    if(this.importOrderInfo){
      this.selectedCountryTo = this.countries.find(x => x.id == this.directSaleFormGroup.controls['destinationCountryId'].value)

      if(this.directSaleFormGroup.controls['destinationCountryId'].value) {
        this._portService.getDestinationPortsByCountry( this.directSaleFormGroup.controls['destinationCountryId'].value).subscribe({
          next: (v) => {
            this.ports = v
            this.loading = false;
          },
          error: (e) => {
            console.log(e)
            this.loading = false
            this._messageService.add({ severity: 'error',
              summary: this.translate.instant('MessageService.Summary.FailedAction'),
              detail: this.translate.instant('MessageService.Port.DestinationPortManyRetrieveError') })
          },
          complete: () => console.info('Destination Ports query successfully')
        })
      }
    }
  }

  getAirPorts()
  {
    if(this.importOrderInfo)
    {
      this.selectedCountryTo = this.countries.find(x => x.id ==  this.directSaleFormGroup.controls['destinationCountryId'].value)
      this.loading = true
      if(this.directSaleFormGroup.controls['destinationCountryId'].value) {
        this._airportService.getDestinationAirportsByCountry( this.directSaleFormGroup.controls['destinationCountryId'].value).subscribe({
          next: (v) => {
            this.airports = v
            this.loading = false
          },
          error: (e) => {
            console.log(e)
            this.loading = false
            this._messageService.add({ severity: 'error',
              summary: this.translate.instant('MessageService.Summary.FailedAction'),
              detail: this.translate.instant('MessageService.Port.DestinationPortManyRetrieveError') })
          },
          complete: () => console.info('Destination Ports query successfully')
        })
      }
    }
  }

  onChangeImportToCountry() {

    if(this.programType === 0){
      this.getPorts();
    }else{
      this.getAirPorts()
    }

  }

  uploadLatamPallets()
  {
    if(this.detail)
    {
      if(this.validateLatamPallets()){
        this.loading = true
        let request: CreatePalletDataRequest = {
          dtos: this.latamPallet,
          importOrderDetailId: this.detail.id
        }

        this._palletService.getLatamPalletsConfiguration(request).subscribe({
          next: (v) => {
            this._messageService.add({ severity: 'success',
              summary: this.translate.instant('MessageService.Summary.SuccessAction'),
              detail:  this.translate.instant('MessageService.Pallet.UploadLatamSuccess') })

              if(this.detail){
                this.detail.hasLatamData = true;
              }
              this.loading = false
              this.visibleLatamLoad = false
          },
          error: (v) => {
            this._messageService.add({ severity: 'error',
              summary: this.translate.instant('MessageService.Summary.FailedAction'),
              detail:  this.translate.instant('MessageService.Pallet.UploadLatamFailed') })

              this.loading = false
          }
        })
      }

    }
  }

  downloadLatamPallets()
  {
    if(this.detail)
      {
        this.loading = true
      this._palletService.generatePreload(this.detail.id).subscribe({
        next: (resultBlob: any) => {
          const contentDisposition = resultBlob.headers.get('content-disposition');
          let nombreArchivo = 'pallets_data_';

          if (contentDisposition) {
            const match = contentDisposition.match(/filename=([^]+);/);
            if (match && match[1]) {
                nombreArchivo += match[1];
            }
          }

          excelUtils.downloadExcel(resultBlob.body, nombreArchivo);
        },
        error: (v) => {
            this._messageService.add({ severity: 'error',
              summary: this.translate.instant('MessageService.Summary.FailedAction'),
              detail:  this.translate.instant('MessageService.Pallet.DownloadPreloadFailed') })
        }
      })
    }
  }

  validateLatamPallets(): boolean{
    let isValid = true;

    this.latamPallet.forEach((x , i) => {

      if(!this.isDivisible(x.boxes, x.pallets))
      {
        let params = {lineNumber: i + 1}
        this._messageService.add({ severity: 'error',
          summary: this.translate.instant('MessageService.Summary.FailedAction'),
          detail:  this.translate.instant('MessageService.Pallet.ValidateDivisorPallet', params)})
        isValid = false;
      }
    })
    return isValid;
  }

  isDivisible(num: number, div: number){
    return num % div === 0;
  }

  changeDiv(event: string)
  {
    this.showDiv = event
  }

  getAllQcType()
  {
    this.operationDocumentTypes =  []
    this.loading = true;
    this._operationDocumentTypeService.getAllQcType().subscribe({
      next: (v) => {
        this.operationDocumentTypes = v;
        this.loading = false
      },
      error: (e) => {
        this._messageService.add({ severity: 'error',
          summary: this.translate.instant('MessageService.Summary.FailedAction'),
          detail: this.translate.instant('MessageService.ExportOfferDocument.ManyRetrieveError') });
          this.loading = false
      }
    })
  }

    onSelect(event: any) {
    this.uploadedFiles = []
    for(let file of event.files) {
        this.uploadedFiles.push(file);
    }

    if(event.files[0])
      this.name = event.files[0].name
  }

  onSelectDocumentType(event: any) {
  this.documentTypeViewId = event.value
  }

    upload(){
      this.loading = true

      if(!this.uploadedFiles[0])
      {
        this.loading = false;
        this._messageService.add({ severity: 'error',
          summary:this.translate.instant('MessageService.Summary.FailedAction'),
          detail: this.translate.instant('UploadDocumentDialog.LoadDocumentMessage') })

      }else{

        if(this.dto)
        {
            const uploadFileRequest: UploadOperationFileRequest = {
            orderId: this.dto.importOrderDetail.importOrderId,
            name: this.name,
            pdf: this.uploadedFiles[0],
            operationDocumentTypeId: this.documentTypeViewId
          }
          this._operationService.uploadFile(uploadFileRequest).subscribe({
            next: (v) => {
              this._messageService.add({ severity: 'success',
                summary: this.translate.instant('MessageService.Summary.SuccessAction'),
                detail: this.translate.instant('UploadDocumentDialog.UploadDocumentSuccess') })
              this.loading = false
              this.visibleOperationUploadDialog = false;
            },
            error: (e) => {
              this.loading = false
              console.log(e)
              this._messageService.add({ severity: 'error',
                summary: this.translate.instant('MessageService.Summary.FailedAction'),
                detail: this.translate.instant('UploadDocumentDialog.UploadDocumentError') });
            },
            complete: () => {
              this.loading = false
            }
          })
      }

      }
    }


  getLoadPalletsStepTitle() {
    if (this.loadPalletsStep === 1 || this.loadPalletsStep === 2) {
      return this.translateInfo('LoadInformationTitle')
    }
    else {
      return this.translateInfo('LoadedInformationTitle')
    }
  }

  getLoadPalletsStepDetail() {
    if (this.loadPalletsStep === 1) {
      return this.translateInfo('LoadInformationDetailText')
    }
    else if (this.loadPalletsStep === 2) {
      return this.translateInfo('EditInformationDetailText')
    }
    else {
      return this.translateInfo('LoadedInformationDetailText')
    }
  }

  onChangeLoadPalletsTab(value: any) {
    if (value.index === 0) {
      this.loadPalletsStep = 1;
      this.copyPasteExcelService.setIsDisplayTable(false);
      this.copyPasteExcelService.setIsClearTextArea();
    }
    if (value.index === 1) {
      this.palletFormGroup.controls['endRow'].setValue(null)
      this.excelFile = null
      this.excelSheets = null
      this.startRow = 1
      this.folioColumn = ''
      this.caliberColumn = ''
      this.producerColumn = ''
    }
  }

  getPastedPallets(hasText: boolean) {
    this.loadPalletsStep = hasText ? 2 : 1;
  }

  loadPalletsNextStep() {
    if (this.loadPalletsStep === 2) {
      this.copyPasteExcelService.setIsDisplayTable(true);
    }
    if (this.loadPalletsStep === 3) {
      this.copyPasteExcelService.getExcelFile()?.pipe(take(1)).subscribe((data) => {
        this.excelFile = data.fileBlob;
        this.selectedSheet = data.sheetName;
        this.palletFormGroup.controls['endRow'].setValue(data.rowsAmount)
        this.generatePallets(data.rowsAmount);
        this.onLoadExcel2();
      })
      return
    }
    this.loadPalletsStep = this.loadPalletsStep + 1;
  }

  loadPalletsPreviousStep() {
    if (this.loadPalletsStep === 2) {
      this.copyPasteExcelService.setIsClearTextArea();
    }
    this.copyPasteExcelService.setIsDisplayTable(false);

    if (this.loadPalletsStep > 1) {
      this.loadPalletsStep = this.loadPalletsStep - 1;
    }
  }

  onCloseLoadInformationDialog() {
    this.visibleLoadInformation = false;
  }

  ngOnDestroy(): void {
    // sessionStorage.setItem('_verify_pallets_active_index', this.activeIndex.toString());
    //sessionStorage.setItem('_verify_pallets_active_detail_id', this.dto?.importOrderDetail.id.toString());
    this.destroy.next();
    this.destroy.complete();
  }

  assignOrder()
  {
    this.visibleStockDialog = false;
    this.verifyDeleteConfig = false;
    this.updatePalletEvent.emit();
  }

  cancelOrder()
  {
    this.visibleStockDialog = false;
  }

  @ViewChild('assignStockComponent') assignStockComponent!: AssignStockComponent

  invokeAssignPalletStock()
  {
    if(this.assignStockComponent){
      this.assignStockComponent.assignStock()
    }
  }

  goToAssignPalletStock()
  {
    if(this.detail)
    {
      if(this.detail.importOrderId)
      {
        const url = this._router.serializeUrl(
        this._router.createUrlTree([`${Routes.userAssignStockOrder}/${this.detail.id}`]))
        window.open(url, '_blank');
      }
    }

  }
}
